import {observer} from 'mobx-react';
import {t} from 'shared/core';

const LieuTimeNote = observer(({lieuTime}) => {
  if (!parseFloat(lieuTime)) return null;

  return (
    <div className='h6'>{t('time_tracking.payroll_hours.LIEU_TIME_EARNED', {lieuTime})}</div>
  );
});

export default LieuTimeNote;
